import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDataInLocalstorage } from "../../../common/method/getDataInLocalstorage";
import { actionTypes as actionProfile } from "../../../redux/profile/clubmember_select_info";
import UploadImges from "./UploadImages";
import { updateCookieWithProfile } from "common/customHook/initLoginFromQuery";

const ProfileSideBar = ({ open }) => {
  const dispatch = useDispatch();

  const [flagApiProfile, setFlagApiProfile] = useState(false);
  const [stateProfile, setStateProfile] = useState({ id: "", body: {} });
  const user = getDataInLocalstorage();
  const profile = useSelector((state) => state.reducerProfile.data);

  useEffect(() => {
    if (!profile.length) return;
    setStateProfile(profile[0]);

    const interval = setInterval(() => {
      if (window.$nimchat) {
        const profileData = profile[0].body;
        updateCookieWithProfile(profileData.first_name, profileData.last_name);

        window.$nimchat.setUser(profileData.national_id, {
          phone_number: `+${profileData.phone}`,
          name: profileData.first_name + " " + profileData.last_name,
        });

        const bubble = document.querySelector(".woot-widget-bubble");
        if (bubble) {
          bubble.style.setProperty("z-index", "1000", "important");
        }
        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, [profile]);

  useEffect(() => {
    if (user?.member_national_id)
      dispatch({
        type: actionProfile.profileAsync,
        national_id: user?.member_national_id,
      });
  }, [flagApiProfile, user?.member_national_id]); //eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <div className="flex flex-col items-center relative ">
        <UploadImges
          flagMenu={open}
          stateProfile={stateProfile}
          dataUser={stateProfile}
          setFlagApiProfile={setFlagApiProfile}
        />

        {open && (
          <>
            <div className="text-xl mt-5">
              {stateProfile?.body?.first_name} {stateProfile?.body?.last_name}
            </div>

            <div className="w-52 bg-gray-300 mt-3" style={{ height: 2 }}></div>
          </>
        )}
      </div>
    </>
  );
};

export default ProfileSideBar;
